import { ModDashboardThreadDetails } from 'open-modules/zdf/component/moddashboard/moddashboardthreads';

export const EnableModDashboardThreadDetailsFeature = {
    name: 'Enable Mod Dashboard Thread Detail View',
    key: 'enablemoddashboardthreaddetailview',
    dev: true,
    subscreens: {
        moderationDetails: () => <ModDashboardThreadDetails />,
    },
};
